import {
  DESIGN,
  GENERATE_RSS,
  DESIGN_PREVIEW,
  GENERATE_PREVIEW,
  SAVING_DESIGN,
  ALL_ARTICLES_IN_EDITION,
} from '../../constants/actionTypes';
import { IDesignAction, IDesignItem } from './Interfaces';

const designInitialState = {
  data: <IDesignItem>{},
  preview_html: '',
  preview_text: '',
  default_preview_text: '',
  loading: false,
  skeletonLoading: false,
  previewLoading: false,
  regenerateLoading: false,
  disablePreview: true,
  isUpdated: false,
  missingLinkError: false,
  articles: [] as any,
  articlesLoading: false,
  previewChangeSave: false,
  disablePublish: true, // for the purpose of disabling Publish while content is not loaded
  // enablePublish: false,
  tamplateChanged: false,
  rss: {
    open: false,
    load: false,
    success: false,
    error: false,
    link: '',
  },
  saveDesign: {
    loading: false,
    loadText: '',
    success: false,
    successText: '',
    fail: false,
    failText: '',
    emailNameExists: false,
  },
  goToPublishFail: false,
  isDesignUpdate: false,
  workflowActiveWarningShown: false,
  saveAsLoading: false,
  activeTab: 0,
  aiTemplates: {
    templates: [],
    pagination: {},
  },
};

export const designReducer = (state = designInitialState, action: IDesignAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case SAVING_DESIGN.SAVE_AS_SUCCESS:
      new_state.saveAsLoading = action.payload;
      return new_state;
    case GENERATE_PREVIEW.UPDATE:
      new_state.isUpdated = action.isUpdated;
      return new_state;
    case DESIGN.DISABLE_PREVIEW:
      new_state.disablePreview = true;
      return new_state;
    case DESIGN.ENABLE_PREVIEW:
      new_state.disablePreview = false;
      return new_state;
    case DESIGN.RESET_DESIGN:
      new_state.data = {} as IDesignItem;
      return new_state;
    case DESIGN.LOAD_SUCCESS:
      // when design loads successfully
      new_state.data = action.payload as IDesignItem;
      new_state.loading = false;
      return new_state;
    case DESIGN.UPDATE_HTML:
      new_state.data.email_html = action.email_html;
      new_state.data.html = action.html;
      return new_state;
    case DESIGN.LOAD:
      // design loader
      new_state.loading = action.loader;
      return new_state;

    case DESIGN.SKELETON_LOAD:
      new_state.skeletonLoading = true;
      return new_state;

    case DESIGN.SKELETON_LOAD_SUCCESS:
      new_state.skeletonLoading = false;
      return new_state;

    case DESIGN.SET_MISSING_LINK_ERROR:
      new_state.missingLinkError = action.missingLinkError;
      return new_state;

    case DESIGN.EMAIL_NAME_UPDATE:
      const newArray = state.data; //making a new array
      newArray.version_name = action.payload;
      new_state.data = newArray;
      return new_state;
    case DESIGN.RESET:
      // error from api
      new_state.loading = false;
      new_state.data = <IDesignItem>{};
      return new_state;
    case DESIGN.LOAD_FAIL:
      // error from api
      new_state.loading = false;
      return new_state;
    case GENERATE_RSS.LOAD:
      new_state.rss = { ...state.rss, load: true, open: true };
      return new_state;
    case GENERATE_RSS.LOAD_SUCCESS:
      new_state.rss = {
        ...state.rss,
        load: false,
        link: action.rssLink,
        success: true,
      };
      return new_state;
    case GENERATE_RSS.LOAD_FAIL:
      new_state.rss = { ...state.rss, load: false, error: true };
      return new_state;

    case GENERATE_RSS.RESET:
      new_state.rss = {
        ...state.rss,
        load: false,
        open: false,
        error: false,
        success: false,
      };
      return new_state;
    //design preview
    case DESIGN_PREVIEW.LOAD_SUCCESS:
      new_state.previewLoading = false;
      new_state.preview_html = action.preview_html;
      new_state.preview_text = action.preview_text;
      new_state.default_preview_text = action.preview_text;
      return new_state;
    case DESIGN_PREVIEW.ADHOC_RESET:
      new_state.previewLoading = false;
      new_state.data.html = '';
      new_state.data.css = '';
      new_state.data.email_html = '';
      return new_state;
    case DESIGN_PREVIEW.LOAD:
      new_state.previewLoading = true;
      return new_state;
    case DESIGN_PREVIEW.UPDATE_PREVIEW_TEXT:
      new_state.previewLoading = false;
      new_state.preview_text = action.preview_text;
      return new_state;
    case DESIGN_PREVIEW.LOAD_FAIL:
      new_state.previewLoading = false;
      return new_state;
    case DESIGN_PREVIEW.RESET:
      new_state.previewLoading = false;
      new_state.data.html = '';
      new_state.data.css = '';
      new_state.data.email_html = '';
      new_state.preview_html = action.preview_html;
      new_state.preview_text = action.preview_text;
      return new_state;

    // Saving design/template
    case SAVING_DESIGN.LOAD:
      new_state.saveDesign.loading = true;
      new_state.saveDesign.loadText = action.saving_text;
      return new_state;
    case SAVING_DESIGN.LOAD_SUCCESS:
      new_state.saveDesign.loading = false;
      new_state.saveDesign.loadText = '';
      return new_state;
    case SAVING_DESIGN.SUCCESS:
      new_state.saveDesign.loading = false;
      new_state.saveDesign.success = true;
      new_state.saveDesign.successText = action.save_success_text;
      return new_state;
    case SAVING_DESIGN.FAIL:
      new_state.saveDesign.loading = false;
      new_state.saveDesign.fail = true;
      new_state.saveDesign.failText = action.save_fail_text;
      return new_state;
    case SAVING_DESIGN.RESET:
      new_state.saveDesign.loading = false;
      new_state.saveDesign.success = false;
      new_state.saveDesign.fail = false;
      return new_state;
    case SAVING_DESIGN.EMAIL_NAME_ALREADY_EXIST:
      new_state.saveDesign.emailNameExists = action.emailAlreadyExist;
      return new_state;
    case DESIGN.DISABLE_PUBLISH:
      new_state.disablePublish = true;
      return new_state;

    case DESIGN.ENABLE_PUBLISH:
      new_state.disablePublish = false;
      return new_state;

    case DESIGN_PREVIEW.TEMPLATE_CHANGE_ENABLE:
      new_state.tamplateChanged = true;
      return new_state;

    case DESIGN_PREVIEW.TEMPLATE_CHANGE_DISABLE:
      new_state.tamplateChanged = false;
      return new_state;

    // when any curation is updated in edition
    case DESIGN.SET_DESIGN_UPDATE:
      new_state.isDesignUpdate = action.payload;
      return new_state;

    case DESIGN.SET_ACTIVE_WORKFLOW_WARNING:
      new_state.workflowActiveWarningShown = action.payload;
      return new_state;

    case DESIGN.SET_GO_TO_PUBLISH_FAIL:
      new_state.goToPublishFail = true;
      return new_state;

    case DESIGN.SET_GO_TO_PUBLISH_RESET:
      new_state.goToPublishFail = false;
      return new_state;
    case DESIGN.SET_REGENERATE_LOADING:
      new_state.regenerateLoading = action.payload;
      return new_state;
    case DESIGN.AI_TEMPLATES:
      new_state.activeTab = action.payload.activeTab;
      new_state.aiTemplates = action.payload.data;
      new_state.aiTemplates.pagination = action.payload.page;
      return new_state;
    default:
      return new_state;
  }
};
